<template lang="pug">
.v-article.article(v-if="article")
	.article__container.container
		.article__img-wrapper(v-if="article.image")
			template(v-if="Array.isArray(article.image) && article.image.length")
				v-big-slider(:data-source="article.image")
			template(v-else)
				img.article__main-img(v-if="article.image" :src="article.image" alt="" loading="lazy")
				button.article__img-button(v-if="isSm" type="button" @click="goBack")
					v-svg-icon.article__img-icon(icon="back-arrow")
		.article__wrapper
			.article__date(v-if="article.date") {{article.date}}
		.article__content.text-guide(v-if="content" v-html="content")
		.article__slider(v-if="Array.isArray(article.slides) && article.slides.length" )
			v-big-slider(:data-source="article.slides")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import {SwiperSlide} from 'swiper/vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	components: {
		SwiperSlide
	},

	data() {
		return {
			article: null,
			content: null,
			options: {
				spaceBetween: 8,
				slidesPerView: 1,
			},
			allowTouchMove: true,
			pagination: {
				clickable: false
			},
			navigation: false
		};
	},

	methods: {
		//Preparing <img> and <Iframe> from <p> wrapper
		wrapTextInParagraphs(content) {
			const tempDiv = document.createElement('div');
			tempDiv.innerHTML = content;
			const processNode = (node) => {
				if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
					const p = document.createElement('p');
					p.textContent = node.textContent;
					let nextSibling = node.nextSibling;
					while (nextSibling) {
						if (nextSibling.nodeType === Node.ELEMENT_NODE && (nextSibling.tagName === 'IMG' || nextSibling.tagName === 'IFRAME')) {
							break;
						}
						nextSibling = nextSibling.nextSibling;
					}
					node.replaceWith(p);
				} else if (node.nodeType === Node.ELEMENT_NODE) {
					if (node.tagName === 'IMG' || node.tagName === 'IFRAME') {
						node.removeAttribute('height');
					}
					if (node.tagName === 'P') {
						const childNodes = Array.from(node.childNodes);
						const hasImgOrIframe = childNodes.some(child => child.nodeType === Node.ELEMENT_NODE && (child.tagName === 'IMG' || child.tagName === 'IFRAME'));
						if (hasImgOrIframe) {
							const fragment = document.createDocumentFragment();
							childNodes.forEach(child => {
								if (child.nodeType === Node.ELEMENT_NODE && (child.tagName === 'IMG' || child.tagName === 'IFRAME')) {
									child.removeAttribute('height');
									fragment.appendChild(child);
								} else if (child.nodeType === Node.ELEMENT_NODE && child.tagName === 'BR') {
									fragment.appendChild(child);
								}
							});
							node.parentNode.replaceChild(fragment, node);
						} else {
							childNodes.forEach(processNode);
						}
					} else {
						Array.from(node.childNodes).forEach(processNode);
					}
				}
			};
			Array.from(tempDiv.childNodes).forEach(processNode);
			return tempDiv.innerHTML;
		},

		onSwiper() {
			this.navigation = {
				prevEl: this.$refs['article-prev'],
				nextEl: this.$refs['article-next']
			};
		},
		
		dataSet(data) {
			this.article = data;
			if(this.article.content) {
				this.content = this.wrapTextInParagraphs(this.article.content)
			}
		},

		goBack() {
			window.history.back();
		},
	}
};
</script>